import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import { grey } from "@material-ui/core/colors";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Typography from "@material-ui/core/Typography";
import { AccountCircle, ExpandLess, ExpandMore } from "@material-ui/icons";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";
import DonutLarge from "@material-ui/icons/DonutLarge";
import PersonIcon from "@material-ui/icons/Person";
import SecurityIcon from "@material-ui/icons/Security";
import React, { useEffect, useState } from "react";
import { CgArrowsExchangeAltV } from "react-icons/cg";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import useResizer from "../../services/useResizer";
import useWindowDimensions from "../../services/useWindowDimensions";
import CollapsibleListItem from "./CollapsibleListItem/index";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import PaymentIcon from "@material-ui/icons/Payment";
import Switch from "@material-ui/core/Switch";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import { isFirefox } from "react-device-detect";
import ContactSupportIcon from "@material-ui/icons/ContactSupport";
import LanguageIcon from "@material-ui/icons/Language";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Brightness4Icon from "@material-ui/icons/Brightness4";
import Drawer from "@material-ui/core/Drawer";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
} from "@material-ui/core";
import { useDialog } from "../../contexts/DialogProvider";
import { RiSafe2Fill, RiUserSettingsLine } from "react-icons/ri";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import { SET_DARK_MODE } from "../../redux/types";
import ChatSide from "../../assets/navbarIcons/chatSide";
import {
  detectIfFreshchatHasLoaded,
  hideFreshchatInMobile,
} from "../../services/freshchat";
import ReferIconNew from "../../assets/navbarIcons/refericonnew";
import PortfolioNew from "../../assets/navbarIcons/portfolionew";
import WalletNew from "../../assets/navbarIcons/walletnew";
import OrderHistoryIcon from "../../assets/navbarIcons/orderhistoryicon";
import TxnIcon from "../../assets/navbarIcons/txnicon";
import SettingsIcon from "../../assets/navbarIcons/settingsicon";
import SupportIcon from "../../assets/navbarIcons/supporticon";
export default function MobileNavbarDrawer(props) {
  const classes = useStyles();
  let history = useHistory();
  const dispatch = useDispatch();
  const darkMode = useSelector((state) => state.trading.DARK_MODE);
  const [collapse, setCollapse] = useState({});
  const token = useSelector((state) => state.trading.TOKEN);
  const isLoggedIn = Boolean(token);
  const mobileApp = useSelector((state) => state.trading.IS_USING_MOBILE_APP);
  const userProfile = useSelector((state) => state.trading.USER_PROFILE);
  const [accountSettingsDrawer, setAccountSettingsDrawer] = useState(false);
  const isMobile = useResizer();
  const openSetting = useSelector((state) => state.trading.ACC_POPUP);
  const [openDialog, closeDialog] = useDialog();

  const accountSettings = [
    {
      label: "KYC Verification",
      onClick: () => {
        history.push("/onboarding");
      },
    },
    {
      label: "Bank Account",
      onClick: () => {
        history.push("/accsettings?tab=1");
      },
    },
    {
      label: "Nominee",
      onClick: () => {
        history.push("/accsettings?tab=2");
      },
    },
    {
      label: "Security",
      onClick: () => {
        history.push("/accsettings?tab=3");
      },
    },
    {
      label: "Activity Logs",
      onClick: () => {
        history.push("/accsettings?tab=4");
      },
    },
  ];

  const handleAccountSettingsDrawerClose = () => {
    setAccountSettingsDrawer(false);
    dispatch({ type: "SET_ACC_POPUP", payload: false });
  };
  const handleThemeChange = () => {
    dispatch({ type: SET_DARK_MODE, payload: !darkMode });
  };

  function handleLogout() {
    // console.log("Logging out");
    dispatch({ type: "SET_TOKEN", payload: null });
    dispatch({ type: "SET_TOKEN_STATUS", payload: null });
    dispatch({ type: "SET_LOGIN_ID", payload: null });

    window.fcWidget.user.clear();
    history.push(`/login`);

    // window.location.reload();
  }

  function capitalizeFirstLetter(string) {
    if (string) return string.charAt(0).toUpperCase() + string.slice(1);
    else return "";
  }

  // useEffect(() => {
  //   console.log(collapse);
  // }, [collapse]);

  const handleComingSoon = () => {
    openDialog({
      children: (
        <>
          <DialogTitle>Coming Soon</DialogTitle>
          <DialogContent>
            <Typography>
              This page will be available soon! Stay tuned.
            </Typography>
          </DialogContent>
          <DialogActions
            style={{ paddingBottom: "30px", paddingRight: "20px" }}
            className="flex flex-wrap md:flex-nowrap"
          >
            <Button
              variant="contained"
              onClick={() => {
                closeDialog();
              }}
              className="mb-4 md:mb-0 text-sm"
              color="primary"
              style={{ color: "white", fontWeight: "bold" }}
            >
              Okay
            </Button>
          </DialogActions>{" "}
        </>
      ),
    });
  };

  const loggedOutList = () => (
    <div className="">
      {/* <ListItem
        button
        onClick={() => {
          history.push(`/trade/BTC`);
          props.handleDrawerClose();
        }}
      >
        <ListItemIcon>
          <EqualizerIcon></EqualizerIcon>
        </ListItemIcon>
        <ListItemText primary="Trade"></ListItemText>
      </ListItem> */}
      {/* <ListItem
        className="mt-3"
        button
        onClick={() => {
          history.push(`/vault`);
          props.handleDrawerClose();
        }}
      >
        <ListItemIcon>
          <RiSafe2Fill size="24px"></RiSafe2Fill>
        </ListItemIcon>
        <ListItemText
          primary="Vault"
          classes={{ primary: classes.primary }}
        ></ListItemText>
      </ListItem> */}
      <ListItem
        button
        onClick={() => {
          history.push(`/feespage`);
          props.handleDrawerClose();
        }}
      >
        <ListItemIcon>
          <RiMoneyDollarCircleLine size="24px"></RiMoneyDollarCircleLine>
        </ListItemIcon>
        <ListItemText classes={{ primary: classes.primary }} primary="Fees" />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          history.push(`/invite`);
          props.handleDrawerClose();
        }}
      >
        <ListItemIcon>
          <ReferIconNew />
        </ListItemIcon>
        <ListItemText
          classes={{ primary: classes.primary }}
          primary="Refer & Earn"
        />
      </ListItem>
      <ListItem
        button
        onClick={() => {
          if (detectIfFreshchatHasLoaded()) {
            // document.querySelector(
            //   "#fc_frame, #fc_frame.fc-widget-normal"
            // ).style.display = "block";
            window.fcWidget.open();
            window.fcWidget.show();
          }
          props.handleDrawerClose();
        }}
      >
        <ListItemIcon>
          <ChatSide />
        </ListItemIcon>
        <ListItemText
          classes={{ primary: classes.primary }}
          primary="Chat Support"
        />
      </ListItem>

      <CollapsibleListItem
        label="Support"
        icon={<SupportIcon />}
        id={3}
        open={collapse[3] || false}
        onClick={(id, open) => {
          let obj = { [id]: open };
          setCollapse({ ...obj });
        }}
      >
        <div className="">
          <ListItem
            button
            onClick={() => {
              window.open(
                "https://support.pocketbits.in/support/solutions",
                "_blank"
              );
            }}
          >
            <ListItemText
              className="text-base font-medium ml-14"
              primary="FAQ's"
            />
          </ListItem>{" "}
          <ListItem
            button
            onClick={() => {
              window.open(
                "https://support.pocketbits.in/support/tickets/new",
                "_blank"
              );
              props.handleDrawerClose();
            }}
          >
            <ListItemText
              className="text-base font-medium ml-14"
              primary="Create Support Ticket"
            />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              history.push(`/contactus`);
              props.handleDrawerClose();
            }}
          >
            <ListItemText
              className="text-base font-medium ml-14"
              primary="Contact Us"
            />
          </ListItem>
        </div>
      </CollapsibleListItem>
      <CollapsibleListItem
        label="Company"
        className="mb-3"
        icon={<LanguageIcon />}
        id={1}
        open={collapse[1] || false}
        onClick={(id, open) => {
          let obj = { [id]: open };
          setCollapse({ ...obj });
        }}
      >
        {" "}
        <div className="">
          <ListItem
            button
            onClick={() => {
              //coming soon
              history.push(`/aboutus`);
              props.handleDrawerClose();
            }}
          >
            <ListItemText
              className="text-base font-medium ml-14"
              primary="About Us"
            />
          </ListItem>{" "}
          <ListItem
            button
            onClick={() => {
              window.open(`https://pocketbits.in/blog/`, "_blank");
            }}
          >
            <ListItemText
              className="text-base font-medium ml-14"
              primary="Blog"
            />
          </ListItem>
          {/* <ListItem
            button
            onClick={() => {
              //coming soon
              handleComingSoon();
            }}
          >
            <ListItemText primary="Media Mentions" />
          </ListItem> */}
        </div>
      </CollapsibleListItem>
    </div>
  );

  return (
    <>
      <SwipeableDrawer
        anchor="right"
        open={props.open}
        onClose={props.handleDrawerClose}
        onOpen={props.handleDrawerOpen}
        //   disableBackdropTransition={!iOS}
        //   disableDiscovery={iOS}
        classes={{ paper: classes.paper }}
        className="relative"
      >
        <div className="flex relative w-full justify-end">
          <div className="mr-4 z-10 mt-5 absolute text-xl font-bold">
            <CloseIcon
              onClick={props.handleDrawerClose}
              className="cursor-pointer"
            ></CloseIcon>
          </div>
        </div>
        <List className={classes.listRoot}>
          {isLoggedIn && (
            <>
              {" "}
              <div className="flex mt-4 justify-center  flex-col items-center  text-center">
                <AccountCircle style={{ fontSize: "34px" }} />
                <h3 className="break-all my-5 px-3">
                  {capitalizeFirstLetter(userProfile?.firstName)}{" "}
                  {capitalizeFirstLetter(userProfile?.lastName)}
                </h3>
              </div>
              <Divider light />
              {/* <div className="mb-3">
                <ListItem
                  button
                  onClick={() => {
                    history.push(`/portfolio`);
                    props.handleDrawerClose();
                  }}
                >
                  <ListItemText primary="Portfolio"></ListItemText>
                </ListItem>{" "}
                <ListItem
                  button
                  onClick={() => {
                    history.push(`/transactions`);
                    props.handleDrawerClose();
                  }}
                >
                  <ListItemText primary="Transactions" />
                </ListItem>{" "}
                <ListItem
                  button
                  onClick={() => {
                    setAccountSettingsDrawer(true);
                    // history.push(`/onboarding`);
                    props.handleDrawerClose();
                  }}
                >
                  <ListItemText
                    primary="Account settings
"
                  />
                </ListItem>
              </div>
              <Divider light /> */}
              <ListItem
                button
                onClick={() => {
                  history.push(`/portfolio`);
                  props.handleDrawerClose();
                }}
              >
                <ListItemIcon>
                  <PortfolioNew fill={"#FFFFFF"} />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.primary }}
                  primary="Portfolio"
                />
              </ListItem>
              <CollapsibleListItem
                label="Wallet"
                icon={<WalletNew />}
                id={4}
                open={collapse[4] || false}
                onClick={(id, open) => {
                  let obj = { [id]: open };
                  setCollapse({ ...obj });
                }}
              >
                <div className="">
                  <ListItem
                    button
                    onClick={() => {
                      history.push("/wallet/crypto");
                      props.handleDrawerClose();
                    }}
                  >
                    <ListItemText
                      className="text-base font-medium ml-14"
                      primary="Crypto Wallet"
                    />
                  </ListItem>{" "}
                  <ListItem
                    button
                    onClick={() => {
                      history.push("/wallet/INR");
                      props.handleDrawerClose();
                    }}
                  >
                    <ListItemText
                      className="text-base font-medium ml-14"
                      primary="INR Wallet"
                    />
                  </ListItem>
                </div>
              </CollapsibleListItem>
              <ListItem
                button
                onClick={() => {
                  history.push(`/orderhistory`);
                  props.handleDrawerClose();
                }}
              >
                <ListItemIcon>
                  <OrderHistoryIcon fill={"#FFFFFF"} />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.primary }}
                  primary="Order History"
                />
              </ListItem>
              <ListItem
                button
                onClick={() => {
                  history.push(`/transactions`);
                  props.handleDrawerClose();
                }}
              >
                <ListItemIcon>
                  <TxnIcon fill={"#FFFFFF"} />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.primary }}
                  primary="Transactions"
                />
              </ListItem>
              <ListItem
                button
                onClick={() => {
                  setAccountSettingsDrawer(true);
                  history.push(`/onboarding`);
                  props.handleDrawerClose();
                }}
              >
                <ListItemIcon>
                  <SettingsIcon fill={"#FFFFFF"} />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.primary }}
                  primary="Account Settings"
                />
              </ListItem>
              {loggedOutList()}
              <ListItem
                classes={{
                  root: classes.buttonListItemRoot,
                }}
              >
                <Button
                  disableElevation
                  onClick={() => {
                    handleLogout();
                    props.handleDrawerClose();
                  }}
                  variant="contained"
                  color="primary"
                  size="large"
                  className="font-bold text-white  bg-[#303030] text-center normal-case w-full "
                >
                  <div className="flex justify-center items-center">
                    <ExitToAppIcon className="mr-3"></ExitToAppIcon>
                    <div>Log Out</div>
                  </div>
                </Button>
              </ListItem>
            </>
          )}
          {!isLoggedIn && (
            <div className="" style={{ marginTop: "50px" }}>
              <ListItem
                classes={{
                  root: classes.buttonListItemRoot,
                }}
              >
                <Button
                  disableElevation
                  onClick={() => {
                    history.push(`/createacc`);
                    props.handleDrawerClose();
                  }}
                  variant="contained"
                  color="primary"
                  size="large"
                  className="font-bold text-white text-center normal-case w-full "
                >
                  <div className="flex justify-center items-center">
                    <AddCircleIcon className="mr-2"></AddCircleIcon>{" "}
                    <div>Sign Up</div>
                  </div>
                </Button>
              </ListItem>{" "}
              <ListItem>
                <Button
                  classes={{
                    root: classes.buttonRoot, // class name, e.g. `classes-nesting-root-x`
                  }}
                  onClick={() => {
                    history.push(`/login`);
                    props.handleDrawerClose();
                  }}
                  disableElevation
                  variant="contained"
                  size="large"
                  className="text-white text-center normal-case w-full "
                >
                  <div className="flex justify-center items-center font-light">
                    <img
                      className="mr-2"
                      src={
                        require("../../assets/optimized/Landing/Hero Section/Navbar Icons/signIn-icon.svg")
                          .default
                      }
                    ></img>
                    <div>Sign In</div>
                  </div>
                </Button>
              </ListItem>
              {loggedOutList()}
            </div>
          )}
        </List>
        {!mobileApp && (
          <div className="flex items-center absolute bottom-0 ">
            <img
              src={require("../../assets/img/google-play-badge.png").default}
              className="max-w-[50%] cursor-pointer"
              alt="play-store"
              onClick={() => {
                window.open(
                  "https://play.google.com/store/apps/details?id=com.pocketbits",
                  "_blank"
                );
              }}
            ></img>

            <img
              src={require("../../assets/img/ComingSoon-AppStore.png").default}
              className="max-w-[46%] cursor-pointer"
              alt="app-store"
            ></img>
          </div>
        )}
      </SwipeableDrawer>
      <Drawer
        classes={{ paper: classes.accountSettingsPaper }}
        anchor={"right"}
        open={accountSettingsDrawer || openSetting}
        onClose={handleAccountSettingsDrawerClose}
        className="relative"
      >
        <div className="flex w-full justify-end">
          <div className="mr-4 mt-5 text-xl font-bold">
            <CloseIcon
              onClick={handleAccountSettingsDrawerClose}
              className="cursor-pointer"
            ></CloseIcon>
          </div>
        </div>
        <List>
          <ListItem className="mb-3">
            <h1>Account Settings</h1>
          </ListItem>
          <Divider light />
          <div className="w-full flex flex-col gap-y-1 mt-8">
            {accountSettings.map((ele, idx) => (
              <ListItem
                button
                className={classes.accountSettingPill}
                key={idx}
                onClick={() => {
                  handleAccountSettingsDrawerClose();
                  ele.onClick();
                }}
              >
                <p className="font-normal">{ele.label}</p>
                <ChevronRightIcon></ChevronRightIcon>
              </ListItem>
            ))}
          </div>
        </List>
      </Drawer>
    </>
  );
}

const useStyles = makeStyles((darkTheme, isMobile) => ({
  accountSettingPill: {
    padding: "20px 20px",
    margin: "5px 20px",
    display: "flex",
    justifyContent: "space-between",
    width: "90%",
    borderRadius: "8px",
    background:
      "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(75, 80, 94, 1) 0%, rgba(36, 38, 43, 1) 100%)",
  },
  accountSettingsPaper: {
    background:
      darkTheme.palette.type == "dark"
        ? isFirefox
          ? "rgba(0, 0, 0, 1)"
          : "rgba(0, 0, 0, 0.2)"
        : isFirefox
        ? "#fff"
        : "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(255, 255, 255, 0.5)  100%, rgba(255, 255, 255, 0.5) 100%)",
    // backdropFilter: "blur(20px)",
    // width: "80%",

    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    width: "100%",
  },
  buttonListItemRoot: { paddingBottom: "0px" },
  // logoutRoot: { fontWeight: "bolder" },
  buttonRoot: { background: grey[800] },
  listRoot: { height: "calc(100% - 120px)", overflowY: "auto" },
  paper: {
    background:
      darkTheme.palette.type == "dark"
        ? isFirefox
          ? "rgba(0, 0, 0, 1)"
          : "rgba(0, 0, 0, 0.2)"
        : isFirefox
        ? "#fff"
        : "radial-gradient(98.09% 98.09% at 31.51% 23.05%, rgba(255, 255, 255, 0.5)  100%, rgba(255, 255, 255, 0.5) 100%)",
    // backdropFilter: "blur(20px)",
    // width: "80%",

    backdropFilter: "blur(20px)",
    WebkitBackdropFilter: "blur(20px)",
    width: "80%",
  },
  earnIcon: {
    color: darkTheme.palette.type == "dark" ? "#fff" : "#000",
    // backdropFilter: "blur(20px)",
    // width: "80%",
  },
  primary: { fontWeight: "bolder" },
}));
